
<template>
    <section class="content">
        <div class="container-fluid">
            <loader v-if="loading" :type="'table'"/>
            <div v-else>
                <div class="row">
                    <div class="col-12">
                    <h1>{{translate('messages.profile')}}</h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header p-2">
                                <ul class="nav nav-pills">
                                    <li class="nav-item"><a class="nav-link active show" href="#settings" data-toggle="tab">{{translate('messages.settings')}}</a></li>
                                    <li class="nav-item"><a class="nav-link" href="#change-password" data-toggle="tab">{{translate('messages.change_password')}}</a></li>
                                    <li v-if="!$gate.isType(['admin', 'editor'])" class="nav-item"><a class="nav-link" href="#subscription" data-toggle="tab">{{translate('messages.subscription')}}</a></li>
                                </ul>
                            </div><!-- /.card-header -->
                            <div class="card-body">
                                <div class="tab-content">
                                    <!-- Setting Tab -->
                                    <div class="tab-pane active show" id="settings">
                                        <div class="text-center">
                                            <avatar-cropper
                                                v-model="upload_photo_trigger"
                                                :cropper-options="{aspectRatio: 1, zoomable: true, movable: true, viewMode: 1, minContainerWidth: 600, minContainerHeight: 500}"
                                                :upload-handler="uploadPhoto"
                                            />
                                            <img class="profile-user-img img-fluid img-circle mb-2" :src="photo" alt="User image" style="width:250px"><br>
                                            <button type="button" class="btn btn-primary btn-sm" @click="changeUploadPhotoTrigger">
                                                {{translate('messages.select_new_image')}}
                                            </button>
                                        </div>
                                        <form @submit.prevent="updateInfo" class="form-horizontal">
                                            <div class="form-group">
                                                <label for="inputName">{{translate('messages.name')}}</label>
                                                <input type="" v-model="form.name" class="form-control" id="inputName" :placeholder="translate('messages.name')" :class="{ 'is-invalid': form.errors.has('name') }">
                                                <has-error :form="form" field="name"></has-error>
                                                
                                            </div>
                                            <div class="form-group">
                                                <label for="inputEmail">{{translate('messages.email')}}</label>
                                                    <input type="email" v-model="form.email" class="form-control" id="inputEmail" :placeholder="translate('messages.email')"  :class="{ 'is-invalid': form.errors.has('email') }">
                                                    <has-error :form="form" field="email"></has-error>
                                            </div>
                                            <div class="form-group">

                                                <label for="inputLanguage">{{translate('messages.language')}}</label>
                                                <select id="inputLanguage" class="form-control" v-model="form.language" :class="{ 'is-invalid': form.errors.has('language') }">
                                                <option 
                                                    v-for="(language,index) in languages" :key="'lang-'+index"
                                                    :value="index"
                                                    :selected="index == form.language">{{ language }}</option>
                                                </select>
                                                <has-error :form="form" field="language"></has-error>
                                            </div>
                                            <div class="form-group">
                                                <label for="inputEmail">{{translate('messages.interests')}}</label>
                                                    <textarea type="interests" v-model="form.interests" class="form-control" id="inputinterests"  :class="{ 'is-invalid': form.errors.has('interests') }"></textarea>
                                                    <has-error :form="form" field="interests"></has-error>
                                            </div>
                                            <div class="form-group">
                                                <label>{{translate('messages.country')}}</label>
                                                <select id="selectCountry" class="form-control" v-model="form.country" @change="loadCountryCallingCodes(form.country)" :class="{ 'is-invalid': form.errors.has('country') }">
                                                    <option 
                                                        v-for="country in countries" :key="'country-'+country.alpha2Code"
                                                        :value="country.alpha2Code"
                                                        :selected="country.alpha2Code == form.country">{{ country.name }}</option>
                                                </select>
                                                <has-error :form="form" field="country"></has-error>
                                            </div>
                                            <div class="form-group">
                                                <label>{{translate('messages.timezone')}}</label>
                                                <select id="selectTimezone" class="form-control" v-model="form.timezone" :class="{ 'is-invalid': form.errors.has('timezone') }">
                                                    <option 
                                                        v-for="timezone in timezones" :key="'timezone-'+timezone"
                                                        :value="timezone"
                                                        :selected="timezone == form.timezone">{{ timezone }}</option>
                                                </select>
                                                <has-error :form="form" field="country"></has-error>
                                            </div>
                                            <div class="form-group">
                                                <label for="inputMobilePhone">{{translate('messages.mobile_phone')}}</label>    
                                                <div class="input-group">
                                                    <div class="input-group-prepend">
                                                        <select class="form-control" v-model="form.country_calling_code" :class="{ 'is-invalid': form.errors.has('country_calling_code') }">
                                                            <option 
                                                                v-for="country_calling_code in country_calling_codes" :key="'country_calling_code-'+country_calling_code"
                                                                :value="country_calling_code"
                                                                :selected="country_calling_code == form.country_calling_code">{{ country_calling_code }}</option>
                                                        </select>
                                                    </div>
                                                    <input type="text" v-model="form.mobile_phone" class="form-control" id="inputMobilePhone" :placeholder="translate('messages.mobile_phone')"  :class="{ 'is-invalid': form.errors.has('mobile_phone') }">
                                                    <has-error :form="form" field="mobile_phone"></has-error>
                                                </div>
                                                <div v-if="mobile_phone_status != ''">
                                                    {{translate('messages.status')}}:
                                                    <span v-if="mobile_phone_status == 'verificated'" class="ml-2 text-success">{{translate('messages.verificated')}}</span>
                                                    <span v-else class="ml-2 text-warning">{{translate('messages.pending')}}</span>
                                                </div>
                                            </div>
                                            <div v-if="mobile_phone_status && mobile_phone_status != 'verificated'" class="form-group">
                                                <div class="mb-1">{{translate('messages.mobile_phone_pending_verification_message')}}</div> 
                                                <div class="input-group input-group-sm mb-3" style="width: 250px" @keypress="isNumber($event)">
                                                    <input id="mobile_phone_verification_code" type="text" class="form-control" :placeholder="translate('messages.mobile_phone_verification_code')" maxlength="4">
                                                    <span class="input-group-append">
                                                        <button type="button" class="btn btn-info btn-flat" @click="verificateMobilePhone()">{{translate('messages.verificate')}}</button>
                                                    </span>
                                                    <div id="verification-code-message" class="invalid-feedback d-none"></div>
                                                </div>
                                                <div class="mb-1">{{translate('messages.mobile_phone_verification_code_resend_message')}}</div> 
                                                <div>
                                                    <button type="button" class="btn btn-sm btn-default" @click="resendVerificationCode()">{{translate('messages.resend_verification_code')}}</button>
                                                    <div id="resend-verification-message" class="invalid-feedback d-none"></div>
                                                </div>
                                            </div>
                                            
                                            <div class="form-group">
                                                
                                                <button type="submit" class="btn btn-success">{{translate('messages.update_profile')}}</button>
                                                <div class="float-right d-sm-inline text-muted">{{translate('messages.member_since')}}: <span>{{form.created_at|localDate}}</span></div>
                                            
                                            </div>
                                        </form>
                                    </div>

                                    <!-- Setting Tab -->
                                    <div class="tab-pane" id="change-password">
                                        <div class="form-horizontal">
                                        <div class="form-group">
                                            <label for="current_password">{{translate('messages.current_password')}}</label>

                                        
                                                <input type="password"
                                                    v-model="password_form.current_password"
                                                    class="form-control"
                                                    id="current_password"
                                                    :placeholder="translate('messages.current_password')"
                                                    :class="{ 'is-invalid': password_form.errors.has('current_password') }"
                                                >
                                                <has-error :form="password_form" field="current_password"></has-error>
                                            
                                        
                                        </div>
                                        <div class="form-group">
                                            <label for="new_password">{{translate('messages.new_password')}}</label>

                                        
                                                <input type="password"
                                                    v-model="password_form.new_password"
                                                    class="form-control"
                                                    id="new_password"
                                                    :placeholder="translate('messages.new_password')"
                                                    :class="{ 'is-invalid': password_form.errors.has('new_password') }"
                                                >
                                                <has-error :form="password_form" field="new_password"></has-error>
                                        
                                        </div>

                                        <div class="form-group">
                                            <label for="confirm_password">{{translate('messages.confirm_password')}}</label>

                                            
                                                <input type="password"
                                                    v-model="password_form.confirm_password"
                                                    class="form-control"
                                                    id="confirm_password"
                                                    :placeholder="translate('messages.confirm_password')"
                                                    :class="{ 'is-invalid': password_form.errors.has('confirm_password') }"
                                                >
                                                <has-error :form="password_form" field="confirm_password"></has-error>
                                        
                                        </div>

                                        <div class="form-group">
                
                                            <button @click="updatePassword" class="btn btn-success">{{translate('messages.update_password')}}</button>
                                        
                                        </div>
                                    </div>
                                    </div>

                                    <div class="tab-pane" id="subscription" v-if="!$gate.isType(['admin', 'editor'])">
                                        <div v-if="subscription">
                                            <h2>
                                                <strong>{{translate('messages.status')}}:</strong> 
                                                <span class="text-danger" v-if="subscription.canceled_at">{{translate('messages.canceled')}}</span>
                                                <span class="text-warning" v-else-if="!subscription.is_active">{{translate('messages.ended')}}</span>
                                                <span class="text-success" v-else>{{translate('messages.active')}}</span>
                                            </h2>
                                            <h3>{{subscription.plan_id | plan_id}}</h3>
                                            <div class="my-3">
                                                <p v-if="subscription.canceled_at">
                                                    <strong>{{translate('messages.canceled_at')}}:</strong> {{subscription.canceled_at | localDate}}<br>
                                                    <strong>{{translate('messages.end_date')}}:</strong> {{subscription.ends_at | localDate}} <br><br>
                                                    <a class="btn btn-notiblue" href="/subscribe">{{translate('messages.buy_new_subscription')}}</a>
                                                </p>
                                                <p v-else-if="subscription.is_active">
                                                    <strong>{{translate('messages.next_billing')}}:</strong> {{subscription.ends_at | localDate}} <br><br>
                                                    <a class="btn btn-notiblue mr-2" href="/subscribe">{{translate('messages.update_subscription')}}</a>
                                                    <a class="btn btn-danger" href="/subscribe/cancel">{{translate('messages.go_to_cancel')}}</a>
                                                </p>
                                                <p v-else>
                                                    <a class="btn btn-notiblue" href="/subscribe">{{translate('messages.buy_subscription')}}</a>
                                                </p>
                                            </div>
                                            <hr>
                                        </div>
                                    </div>
                                <!-- /.tab-pane -->
                                </div>
                                <!-- /.tab-content -->
                            </div><!-- /.card-body -->
                        </div>
                        <!-- /.nav-tabs-custom -->
                    </div>
                    <!-- end tabs -->
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        data(){
            return {
                 form: new Form({
                    id:'',
                    name : '',
                    email: '',
                    created_at: '',
                    language: '',
                    interests: '',
                    country: '',
                    country_calling_code: '',
                    mobile_phone: '',
                    timezone: ''
                }),
                 password_form: new Form({
                    current_password: '',
                    new_password: '',
                    confirm_password: ''
                }),
                languages : [],
                loading : true,
                upload_photo_trigger : false,
                photo : '',
                countries: [],
                country_calling_codes: [],
                timezones: [],
                subscription: null,
                mobile_phone_status: null
            }
        },
        mounted() {
            
        },
        methods:{
            loadProfile(){
                axios.get("api/profile")
                .then(({ data }) => {
                    this.form.fill(data.data);
                    this.photo = data.data.photo;
                    this.loading = false;
                    this.loadCountryCallingCodes(data.data.country);
                    this.subscription = data.data.main_subscription;
                    this.mobile_phone_status = data.data.mobile_phone_status;
                });
            },
            updateInfo(){
                this.$Progress.start();
                if(this.form.password == ''){
                    this.form.password = undefined;
                }
                this.form.update({_method:'put'});
                this.form.post('api/profile')
                .then((data)=>{
                    this.$Progress.finish();
                    Toast.fire({
                        icon: 'success',
                        title: data.data.message
                    });
                    if(data.data.data.language != this.$gate.language() || data.data.data.name != this.$gate.name()){
                        window.location.reload();
                    }else{
                        this.loadProfile();
                    }
                })
                .catch((error) => {
                    let error_obj = JSON.parse(error.request.response);
                    let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                    if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                    Toast.fire({
                        icon: 'error',
                        title: error_title
                    });
                    this.$Progress.fail();
                });
            },

            updatePassword(){
                this.$Progress.start();
                this.password_form.post('api/change-password')
                .then((data)=>{
                    //  Fire.$emit('AfterCreate');
                    this.$Progress.finish();
                    this.password_form.current_password = '';
                    this.password_form.new_password = '';
                    this.password_form.confirm_password = '';

                    Toast.fire({
                        icon: 'success',
                        title: data.data.message
                    });
                })
                .catch((error) => {
                    let error_obj = JSON.parse(error.request.response);
                    let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                    if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                    Toast.fire({
                        icon: 'error',
                        title: error_title
                    });
                    this.$Progress.fail();
                });
            },
            loadLanguages(){
              axios.get("/api/profile/languages").then(({ data }) => {
                this.languages = data.data;
              });
            },
            uploadPhoto(crop){
                let photo64 = crop.getCroppedCanvas({width: 512, height: 512}).toDataURL()
                this.$Progress.start();

                axios.post("/api/profile/uploadPhoto", {photo:photo64}).then(({ data }) => {
                    this.$Progress.finish();
                    Toast.fire({
                        icon: 'success',
                        title: data.message
                    });
                    this.loadProfile();
                    $('.user-panel .image img').attr('src', data.data);
                }).catch((error) => {
                    let error_obj = JSON.parse(error.request.response);
                    let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                    if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                    Toast.fire({
                        icon: 'error',
                        title: error_title
                    });
                    this.$Progress.fail();
                });
            },
            changeUploadPhotoTrigger() {
                this.upload_photo_trigger = true;
            },
            loadCountries(){
                axios.get("/api/utils/countries").then(({ data }) => {
                    this.countries = data.data;
                });
            },
            loadCountryCallingCodes(country){
                if(!country){
                    this.country_calling_codes = [];
                    this.form.update({country_calling_code:''});
                    return;
                }
                axios.get("/api/utils/countryCallingCodes/"+country).then(({ data }) => {
                    this.country_calling_codes = data.data.callingCodes;
                    if(!this.country_calling_codes.includes(this.form.country_calling_code)){
                        this.form.update({country_calling_code: this.country_calling_codes[0] ?? ''});
                    }
                });
            },
            loadTimezones(){
                axios.get("/api/utils/timezones").then(({ data }) => {
                    this.timezones = data.data;
                });
            },
            verificateMobilePhone(){
                this.$Progress.start();
                $('#verification-code-message').empty().addClass('d-none').removeClass('d-block');
                $('#mobile_phone_verification_code').removeClass('is-invalid')
                let verification_code = $('#mobile_phone_verification_code').val();
                axios.post("/api/profile/verificateMobilePhone", {mobile_phone_verification_code:verification_code}).then(({ data }) => {
                    this.$Progress.finish();
                    Toast.fire({
                        icon: 'success',
                        title: data.message
                    });
                    this.loadProfile();
                }).catch((error) => {
                    let error_obj = JSON.parse(error.request.response);
                    let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                    if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                    $('#verification-code-message').addClass('d-block').removeClass('d-none').text(error_title);
                    $('#mobile_phone_verification_code').addClass('is-invalid')
                    this.$Progress.fail();
                });
            },
            resendVerificationCode(){
                this.$Progress.start();
                $('#resend-verification-message').empty().addClass('d-none').removeClass('d-block');
                axios.get('/api/profile/resendMobilePhoneVerificationCode').then(({ data }) => {
                    this.$Progress.finish();
                    Toast.fire({
                        icon: 'success',
                        title: data.message
                    });
                    this.loadProfile();
                }).catch((error) => {
                    let error_obj = JSON.parse(error.request.response);
                    let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                    if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                    $('#resend-verification-message').addClass('d-block').removeClass('d-none').text(error_title);
                    this.loadProfile();
                    this.$Progress.fail();
                });
            },
            isNumber(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode == 13 || charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();;
                } else {
                    return true;
                }
            }
        },
        created() {
            this.loadCountries();
            this.loadTimezones();
            this.loadLanguages();
            this.loadProfile();
        },
        filters: {
            plan_id: function (value) {
                switch(value){
                    case 1:
                        return translate('messages.basic_plan');
                    case 2:
                        return translate('messages.professional_plan');
                    case 3:
                        return translate('messages.plus_plan');
                    case 4:
                        return translate('messages.agreement_plan');
                    default:
                        return ''
                }
            }
        }
    }
</script>
